import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, tap } from 'rxjs/operators';
import { Observable, combineLatest, of } from 'rxjs';
import { PanAppState } from '@panamax/app-state';
import { ListsService } from '../services/lists.service';

@Injectable({
  providedIn: 'root',
})
export class ListsResolverService {
  constructor(
    private listsService: ListsService,
    private panAppState: PanAppState,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    const shouldFetchChanges =
      route.queryParamMap.get('getChanges') !== 'false';
    if (shouldFetchChanges) {
      return combineLatest([
        this.panAppState.customer$,
        this.panAppState.session$,
        this.listsService.listStatesAreLoaded$(),
      ]).pipe(
        tap(([currentCustomer, currentSession, loaded]) => {
          const customersAreTheSame =
            currentCustomer?.customerNumber ===
            currentSession?.selectedCustomerId;
          // If the state is loaded and our customer id matches with our session customer id, it is safe to make this call
          if (loaded && customersAreTheSame) {
            this.listsService.fetchListChanges();
          }
        }),
        map(() => true),
      );
    }
  }
}
